import { Avatar } from 'antd';
import React from 'react';
import Panel from '../../../../components/outline/Panel';
import styles from './WidgetHomeMenu.module.scss';

const WidgetHomeMenu = ({ homeMenu, selectedMenuItemId, onClickMenuItem }) => {
  const handleClickMenuItem = (itemId) => {
    onClickMenuItem(itemId);
  };

  return (
    <Panel>
      <div className={`panel-header`}>
        <div className="title">메뉴 화면 구성</div>
        <div className={styles.description}>*메뉴를 편집하려면 편집하고자 하는 메뉴를 클릭하세요.</div>
      </div>

      <ul className={styles.homeMenu}>
        {homeMenu.map((item) => {
          return (
            <li key={item.id}>
              <div
                className={selectedMenuItemId && selectedMenuItemId === item.id ? styles.on : ''}
                onClick={() => handleClickMenuItem(item.id)}
              >
                <div>{item.id}</div>
                <div>
                  {item.url ? (
                    <>
                      <img src={item.url} width={64} height={64} alt="아이콘" className={styles.menuIcon} />
                    </>
                  ) : (
                    <Avatar src={item.url} alt="icon" size={64} shape="square">
                      M
                    </Avatar>
                  )}
                </div>
                <div className={styles.menuItemTitle}>
                  <span>{item.title}</span>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </Panel>
  );
};

export default WidgetHomeMenu;
